export enum ReviewStatus {
    DRAFT = 'draft',
    IN_REVIEW = 'inReview',
    DISAPPROVED = 'disapproved',
    APPROVED = 'approved'
}

export const StatusMapping={
    "Approved":ReviewStatus.APPROVED, "Pending Review":ReviewStatus.IN_REVIEW, "Disapproved":ReviewStatus.DISAPPROVED
}

export enum ItemType {
    CustomJs = 'customJs',
    App = 'app'
}